module.exports = __webpack_public_path__ + "img/chat-ai-libai-active.f8f171a9.svg";